import {
  Procedure
} from '@/Domain/Procedures'
import { ProcedureType } from './ProcedureType'
import { ProcedureStatus } from './ProcedureStatus'
import { Province } from './Province'
import { ApplicationStatus } from './ApplicationStatus'
import { ProcedureBatches } from './ProcedureBatches'
export class UserProcedure {
  private _procedure: Procedure
  private _applicationStatus: ApplicationStatus
  private _batches: ProcedureBatches

  constructor (
    procedure: Procedure,
    applicationStatus: ApplicationStatus,
    batches: ProcedureBatches
  ) {
    this._procedure = procedure
    this._applicationStatus = applicationStatus
    this._batches = batches
  }

  procedureId (): string {
    return this._procedure.procedureId()
  }

  procedureType (): ProcedureType {
    return this._procedure.procedureType()
  }

  status (): ProcedureStatus {
    return this._procedure.status()
  }

  province (): Province {
    return this._procedure.province()
  }

  dogaUrl (): string {
    return this._procedure.dogaUrl()
  }

  dogaDate (): string {
    return this._procedure.dogaDate()
  }

  dogaNumber (): number {
    return this._procedure.dogaNumber()
  }

  celebrationPlace (): string {
    return this._procedure.celebrationPlace()
  }

  celebrationDate (): string {
    return this._procedure.celebrationDate()
  }

  celebrationTime (): string {
    return this._procedure.celebrationTime()
  }

  dateLimit (): string {
    return this._procedure.dateLimit()
  }

  applicationStatus (): string {
    return this._applicationStatus
  }

  batches (): string {
    return this._batches.value()
  }
}
